export const projects = [
    {
        name: 'Teammates Finding (TF)',
        description: 'TF is a university assignment project that helps students find teammates for their projects more efficiently.',
        note: 'The app may be down because it is on the free database plan, which shuts off after periods of inactivity.',
        stack: 'JavaScript, HTML, CSS, React',
        link: 'https://github.com/pdtbinh/TF_frontend',
    },
    {
        name: 'Todos (TD)',
        description: 'TD is a full-stack web application allowing users to note their reminders.',
        note: 'The app may be down because it is on the free database plan, which shuts off after periods of inactivity.',
        stack: 'TypeScript, HTML, CSS, React, Express, PostgreSQL, Node',
        link: 'https://github.com/pdtbinh/full-stack-todo-app/tree/server',
    },
    {
        name: 'CommonLit Readability (CR)',
        description: 'CR is a machine learning (ML) project that involves using natural language processing (NLP) to grade the complexity of literature essays for classroom use.',
        note: 'Running large language model (LLM) may require a dedicated GPU.',
        stack: 'Python, TensorFlow, Keras, scikit-learn, BERT',
        link: 'https://github.com/pdtbinh/CommonLit_Readability_ML_Kaggle'
    },
    {
        name: 'Style Transfer (ST)',
        description: 'ST is a machine learning (ML) project that involves using image processing to fuse the style of one image with the content of another.',
        stack: 'Python, TensorFlow',
        link: 'https://github.com/pdtbinh/Style_transfer'
    },
    {
        name: 'Shapeshifter Game (SSG)',
        description: 'SSG is a hyper-casual mobile game built with Unity.',
        note: 'The game was released to Google Play Store, but it may be archived now.',
        stack: 'C-Sharp (C#), Unity',
        link: 'https://github.com/pdtbinh/Unity_LunaNight-Game'
    },
    {
        name: 'Interpolation Animator (IA)',
        description: 'IA is an Android application that is used to produce interpolated animation from two static frames.',
        note: 'The application was released to Google Play Store, but it may be archived now.',
        stack: 'Java, Android Studio',
        link: 'https://github.com/pdtbinh/Android_Interpolation-Animator'
    },
    {
        name: 'Batman Text-Based Game (BTG)',
        description: 'BTG is a text-based adventure game where users are given the opportunity to explore a scene and solve riddles.',
        stack: 'Scala, Swing, Eclispe',
        link: 'https://github.com/pdtbinh/CS-A1110_Batman-TextBased-Game'
    }
]